module.exports = __webpack_public_path__ + "static/assets/57593d3aac258d2c0abf75a0b8ecbdaa.svg";